// Resume-template typefaces are only needed where a resume is rendered, so they
// load on first use instead of blocking every page (incl. the landing page).
const HREF =
  "https://fonts.googleapis.com/css2?family=IBM+Plex+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;1,400&family=Cormorant+Garamond:ital,wght@0,400;0,500;0,600;0,700;1,400&family=Roboto+Mono:wght@400;500;600;700&family=Playfair+Display:ital,wght@0,400;0,500;0,600;0,700;0,800;1,400&family=Space+Grotesk:wght@400;500;600;700&display=swap";

export function loadTemplateFonts() {
  if (typeof document === "undefined" || document.getElementById("rp-template-fonts")) return;
  const link = document.createElement("link");
  link.id = "rp-template-fonts";
  link.rel = "stylesheet";
  link.href = HREF;
  document.head.appendChild(link);
}
